/**
 * Lightweight HTML sanitizer for admin-authored rich text.
 * Strips dangerous tags/attrs but preserves formatting tags + inline styles.
 */
export function sanitizeHtml(html) {
  if (!html) return "";
  let out = String(html);
  out = out.replace(/<\/?(script|style|iframe|object|embed|link|meta)[^>]*>/gi, "");
  out = out.replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  out = out.replace(
    /\sstyle\s*=\s*("[^"]*(?:expression|javascript:|url\s*\()[^"]*"|'[^']*(?:expression|javascript:|url\s*\()[^']*')/gi,
    ""
  );
  out = out.replace(
    /(href|src)\s*=\s*("javascript:[^"]*"|'javascript:[^']*'|javascript:[^\s>]+)/gi,
    '$1="#"'
  );
  return out;
}

export function isHtmlString(str) {
  return typeof str === "string" && /<\/?[a-z][\s\S]*>/i.test(str);
}

export function normalizeRichTextHtml(html) {
  const safe = sanitizeHtml(html);
  if (!safe || typeof document === "undefined") return safe;

  const template = document.createElement("template");
  template.innerHTML = safe;

  template.content.querySelectorAll(".rt-columns").forEach((block) => {
    const cols = Array.from(block.children).filter((child) =>
      child.classList?.contains("rt-column")
    );
    if (!cols.length) return;

    block.setAttribute("data-columns", String(cols.length));
    block.classList.remove("rt-columns-2", "rt-columns-3");
    block.classList.add(`rt-columns-${cols.length}`);

    const weights = cols.map((col) => {
      const n = Number(col.getAttribute("data-width"));
      return Number.isFinite(n) && n > 0 ? n : 1;
    });
    block.style.gridTemplateColumns = weights.map((w) => `${w}fr`).join(" ");

    block
      .querySelectorAll(".rt-column-tools, .rt-resize-handle")
      .forEach((node) => node.remove());
  });

  return template.innerHTML;
}
